<div class="form-group">
  <div>
    <h2>OT Schedule Upload</h2>
    
  </div>
</div>
<div class="row" *ngIf="error" class="text text-danger">
  <div class="col-md-12">
    {{error}}
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <a href="../../../assets/ot_schedule.xlsx">Sample OT Schedule Excel Sheet</a>
  </div>
</div>
<div class="row p-3">
  <div class="col-md-12 bg-white">

    <app-header-logo [msg]="'Drop excel file here'" [header]="" [url]="'otschedule'" [docType]="'ot_schedule'"
      [img_width]="'200px'" [fileType]="fileType" [uploadType]="uploadType" (docError)="ondocError($event)"
      (docImport)="ondocImport($event)" [dropZoneId]="'mydropzone_otschedule'"></app-header-logo>


  </div>
</div>


<div *ngIf="dataAvailable" class="row" style="overflow: auto; height:300px;">
  <div class="col-md-12 table-wrapper-scroll-y my-custom-scrollbar height:100px">
    <table class="table table-hover table-outline mb-0" style="background-color: white;">
      <thead class="thead-default" style=" background-color: #c2cfd6;">
        <tr>
          <th>Candidate User ID<app-required></app-required>  </th>
          <th>Candidate Exam ID<app-required></app-required>  </th>
          <th>Status<app-required></app-required> </th>
          <th>Obtained Marks</th>
          <th>Total Marks</th>
          <th>Percentage</th>
          <th>Report Status<app-required></app-required>  </th>
          <th>Error</th>
        </tr>
      </thead>
      <tr *ngFor="let t of otScheduledata;" style="cursor:pointer">
        <td>{{t.can_userid}}</td>
        <td>{{t.can_examid}}</td>
        <td>{{t.status}}</td>
        <td>{{t.obtained_marks}}</td>
        <td>{{t.total_marks}}</td>
        <td>{{t.percentage}}</td>
        <td>{{t.report_status}}</td>
        
        <td>
         <span style="color:red" *ngIf="t.error"> {{t.error}}</span>
        </td>


      </tr>
    </table>
  </div>
</div>

<div *ngIf="dataAvailable && errorCount == 0" class="row p-2">
  <div class="col-md-12 text-center text-success text-bold">
    <h5>Total {{dataCount}} records, Please click on confirm button to import.</h5>
    <button class="btn btn-success btn-md" type="button" (click)="onConfirm()">
      Confirm
    </button>
  </div>
</div>

<div *ngIf="dataAvailable && errorCount > 0" class="row p-2">
  <div class="col-md-12 text-center text-success text-bold">
    <h5>Total {{dataCount}} records, Total Errors {{errorCount}}. Fix error first</h5>
    
  </div>
</div>


<div class="col-md-6">
  <ngb-alert *ngIf="successMessage" type="success" (close)="successMessage = null">{{ successMessage }}

  </ngb-alert>
  <ngb-alert *ngIf="errorMessage" type="danger" (close)="errorMessage = null">{{ errorMessage }}

  </ngb-alert>
</div>